var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",class:{ dropShadow: _vm.dropShadow, hasLabel: !!_vm.label },attrs:{"type":"button","data-size":_vm.size},on:{"click":() => _vm.$emit('click')}},[_vm._t("default"),(_vm.label)?_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }